import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);

// Build-time Puppeteer prerender stamps `data-prerendered="1"` on <html>
// and injects `window.__PRERENDER_CACHE__` as a <script> before </body>.
// When present we call `hydrateRoot` (not createRoot) so React reuses the
// pre-rendered DOM instead of blowing it away. The axios interceptor in
// src/lib/api.js consumes __PRERENDER_CACHE__ during the very first GET so
// data is available synchronously on hydration — no flash of "Loading" or
// "Page not found" between hydration and API resolve. For every other
// route (dev, no-snapshot routes, admin) the original createRoot path
// runs as before.
if (document.documentElement.getAttribute("data-prerendered") === "1") {
  ReactDOM.hydrateRoot(container, app, {
    // Surfaces the FULL hydration mismatch reason + React componentStack
    // even in a production bundle. Without this hook React swallows the
    // recoverable error into a minified #418 log with no context.
    onRecoverableError: (err, errorInfo) => {
      // eslint-disable-next-line no-console
      console.error(
        "[hydrate-recover] message=",
        err && err.message,
        "digest=",
        err && err.digest,
        "componentStack=",
        errorInfo && errorInfo.componentStack
      );
    },
  });
} else {
  const root = ReactDOM.createRoot(container);
  root.render(app);
}
